import React, { Component } from "react";
import { connect } from "react-redux";
import { userLogin } from "../../store/actions/auth/login";

class User extends Component {
  componentDidMount = () => {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) return;
    this.props.userLogin(this.redirectToHomepage);
  };

  redirectToHomepage = () => {
    this.props.history.push("/");
  };

  render() {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      this.props.history.push({ pathname: "/", state: { showEntitySearch: true } });
    }
    return <></>;
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
    isPending: state.authentication.isPending,
    userData: state.authentication.userData,
    messageId: state.authentication.userData
      ? state.authentication.userData.inResponseTo
      : "",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userLogin: (redirect) => dispatch(userLogin(redirect)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(User);
